import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the tablePerfilOpcionesView.
 * @extends JetView
 */
export default class tablePerfilOpcionesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        // Configuration for the first double list
        var list1 = {
            view: 'dbllist',
            id: 'dbllist',
            list: { height: 200, scroll: true },
            labelLeft: _('Menus no permitidos'), // Left label for the double list
            labelRight: _('Menus Permitidos'), // Right label for the double list
            data: [], // Initial data
        };

        // Configuration for the second double list
        var list2 = {
            view: 'dbllist',
            list: { autoheight: true },
            labelLeft: 'Available screens', // Left label for the second double list
            labelRight: 'Selected', // Right label for the second double list
            data: [
                // Initial data for the second double list
                { id: '1', value: 'Contacts' },
                { id: '2', value: 'Products' },
                { id: '3', value: 'Reports' },
                { id: '4', value: 'Customers' },
                { id: '5', value: 'Deals' },
            ],
        };

        // Extending the summTreeColumn data filter
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result
                    var resultFormat = 0; // Initialize formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                    });
                    resultFormat = webix.i18n.priceFormat(result); // Format the result
                    node.firstChild.innerHTML = resultFormat; // Update the node's inner HTML
                },
            },
            webix.ui.datafilter.summColumn, // Extend from summColumn
        );

        // Return the main form configuration
        return {
            view: 'form',
            id: 'f1',
            rows: [
                { template: 'Menus', type: 'section' }, // Section header
                {
                    view: 'richselect', // Dropdown for roles
                    name: 'roles',
                    id: 'roles',
                    label: _('Tipo'), // Label for the dropdown
                    labelPosition: 'top',
                    options: [
                        // Options for the dropdown
                        { id: 'ADMIN', value: _('ADMIN') },
                        { id: 'ADMIN2', value: _('ADMIN2') },
                        { id: 'ADMINPARTNER', value: _('ADMIN PARTNER') },
                        { id: 'ADMINAGGREGATOR', value: _('ADMIN AGGREGATOR') },
                        { id: 'CAJERO', value: _('CAJERO') },
                        { id: 'CONCESIONARIO', value: _('CONCESIONARIO') },
                        { id: 'CONCESIONARIO2', value: _('CONCESIONARIO2') },
                        { id: 'OPERADOR', value: _('OPERADOR') },
                        { id: 'PUNTOVENTA', value: _('PUNTOVENTA') },
                        { id: 'SA', value: _('SA') },
                        { id: 'CONSULTAS', value: _('CONSULTAS') },
                        { id: 'ADMINAFILIADOS', value: _('ADMINAFILIADOS') },
                        { id: 'FINANCIERO', value: _('FINANCIERO') },
                        { id: 'CONTABILIDAD', value: _('Contabilidad') },
                        { id: 'CUSTOM', value: _('CUSTOM') },
                    ],
                },
                {
                    view: 'combo', // Combo box for username
                    name: 'Username',
                    id: 'Username',
                    label: _('Usuario'), // Label for the combo box
                    labelPosition: 'top',
                    options: {
                        keyPressTimeout: 1000, // Delay for key press
                        body: {
                            dataFeed: devConfig.geturlApi() + 'Admin/GetUsersSearch', // API endpoint for user search
                            ready: function () {
                                webix.message(this.data.getFirstId()); // Show first user ID
                                this.select(this.data.getFirstId()); // Select first user
                            },
                        },
                    },
                },
                {
                    view: 'forminput', // Input for access permissions
                    name: 'access',
                    body: list1, // Body is the first double list
                    labelWidth: 140,
                    labelAlign: 'right',
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        var values = ''; // Initialize values

        // Event handler for changes in the double list
        $$('dbllist').attachEvent('onChange', function (id, e, node) {
            console.log(values); // Log current values
            var array1 = values.split(','); // Split current values into an array
            var array2 = $$('dbllist').getValue().split(','); // Get new values from the double list
            var arrayAgregados = []; // Array for added permissions
            var arrayEliminados = []; // Array for removed permissions

            // Determine added permissions
            array2.forEach(function (obj) {
                var found = array1.find(function (element) {
                    return element == obj; // Check if the object exists in the old array
                });
                if (found == undefined) {
                    arrayAgregados.push(obj); // Add to added permissions if not found
                }
            });

            // Determine removed permissions
            array1.forEach(function (obj) {
                var found = array2.find(function (element) {
                    return element == obj; // Check if the object exists in the new array
                });
                if (found == undefined) {
                    arrayEliminados.push(obj); // Add to removed permissions if not found
                }
            });

            values = $$('dbllist').getValue(); // Update current values
            console.log(arrayAgregados); // Log added permissions
            console.log(arrayEliminados); // Log removed permissions

            var roleId = $$('roles').getValue(); // Get selected role ID
            var userId = $$('Username').getValue(); // Get selected user ID

            // Confirm user selection for CUSTOM role
            if (roleId == 'CUSTOM' && (userId == 0 || userId == '')) {
                webix.confirm({
                    type: 'confirm-warning',
                    text: _('Error!') + '<br/>' + _('Debe de seleccionar un usuario.'),
                    ok: _('OK'),
                    cancel: _('Salir'),
                    callback: function (action) {
                        if (action === true) {
                            // Action on confirmation
                        }
                    },
                });
                return; // Exit if confirmation is shown
            }

            // Send permissions to the server
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type
                })
                .post(
                    devConfig.geturlApi() + 'UserManagement/SavePermissionsForRole', // API endpoint for saving permissions
                    '{"roleId":"' +
                        roleId +
                        '","userId":"' +
                        userId +
                        '","permAdd":"' +
                        arrayAgregados +
                        '","permDelete":"' +
                        arrayEliminados +
                        '"}', // Payload
                    {
                        error: function (text, data, XmlHttpRequest) {
                            webix.message(_('Error! ')); // Show error message
                        },
                        success: function (text, data, XmlHttpRequest) {
                            // Handle success
                        },
                    },
                );
        });

        // Event handler for changes in the roles dropdown
        $$('roles').attachEvent('onChange', function (newv, oldv) {
            $$('Username').hide(); // Hide username input by default
            if (newv != 'CUSTOM') {
                // If role is not CUSTOM, fetch permissions
                webix
                    .ajax()
                    .headers({
                        'Content-type': 'application/json', // Set content type
                    })
                    .post(
                        devConfig.geturlApi() + 'UserManagement/GetGroupPermissions?roleId=' + newv, // API endpoint for fetching permissions
                        '',
                        {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message(_('Error! ')); // Show error message
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var data = JSON.parse(
                                    text
                                        .replace(/"UserName"/g, '"id"') // Replace keys for parsing
                                        .replace(/"Name"/g, '"value"'),
                                );
                                $$('dbllist').parse(data.Data.ExcludedPermissions); // Parse excluded permissions
                                $$('dbllist').setValue(data.Data.IncludedPermissionList); // Set included permissions
                                values = data.Data.IncludedPermissionList; // Update current values
                            },
                        },
                    );
            } else {
                $$('dbllist').hide(); // Hide double list for CUSTOM role
                $$('Username').show(); // Show username input
            }
        });

        // Event handler for changes in the username input
        $$('Username').attachEvent('onChange', function (newv, oldv) {
            $$('dbllist').$$('left').clearAll(); // Clear left side of double list
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type
                })
                .post(
                    devConfig.geturlApi() + 'UserManagement/GetGroupPermissions?roleId=CUSTOM&UserId=' + newv, // API endpoint for fetching permissions for CUSTOM role
                    '',
                    {
                        error: function (text, data, XmlHttpRequest) {
                            webix.message(_('Error! ')); // Show error message
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var data = JSON.parse(
                                text
                                    .replace(/"UserName"/g, '"id"') // Replace keys for parsing
                                    .replace(/"Name"/g, '"value"'),
                            );
                            $$('dbllist').parse(data.Data.ExcludedPermissions); // Parse excluded permissions
                            $$('dbllist').setValue(data.Data.IncludedPermissionList); // Set included permissions
                            values = data.Data.IncludedPermissionList; // Update current values
                        },
                    },
                );
        });

        $$('Username').hide(); // Initially hide username input
    }
}

// FILE DOCUMENTED
